
<div style="border-left: 5px solid rgb(207, 121, 1);border-right: 5px solid rgb(207, 121, 1);  font-size: 12px;" >

  <div class="backgroundTela">
    &nbsp;
  </div>

  <mat-tab-group [selectedIndex]="selectedIndex"  animationDuration="100ms" style=" margin-left: 5px;">

    <!--MENU FICHAS -->
    <mat-tab *ngFor="let number of [0];let i=index;" label="📝 Cadastro Operações" >
      <form [formGroup]="formulario" novalidate (ngSubmit)="add()">
        <div>

          <!--Definir o tamanho da tela-->
          <div style=" width: 100%; overflow:hidden; text-align: center; ">

            <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">


                  <table style="width: 98%; margin-left: 10px;   ">
                    <tr>
                      <td style="width: 100%;  ">

                        &nbsp;

                      </td>
                    </tr>

                  </table>

            </div>
            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

          </div>


          <div style="margin-top: 15px; ">
            <!--container ajustado dinamicamente-->
            <div id="divContainer">

              <div id="divAdjustAutoHeight">

                <div style="margin-left: 5px; margin-right: 5px;">

                <!--DIV ESQUERDA-->
                <div id="formAndList">

                  <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                    <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro </div>
                  </div>
                  <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                  <mat-card class="mat-elevation-z8" style="padding: 8px;">


                      <!--container ajustado dinamicamente-->
                      <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">

                              <mat-form-field appearance="outline" >
                                <mat-label>
                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                  <b> Nome da Operação</b>
                                  <i>(Obrigatório)</i>
                                </mat-label>
                                <input matInput formControlName="operNmOperacao" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <mat-label>
                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                  <b> Centro de custo</b>
                                  <i>(Obrigatório)</i>
                                </mat-label>
                                <input matInput formControlName="operDsCentroCusto" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                              </mat-form-field>

                              <div style="width:100%;  text-align: left; margin-top: 18px;">
                                <mat-slide-toggle style="font-size: 12px; " formControlName="isInativo">Cadastro inativo?</mat-slide-toggle>
                              </div>




                              <div style="width: 100%; margin-top: 25px;">

                                <div style="width: 70%; float: left;">
                                  <button mat-raised-button  type="submit"
                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                    Salvar
                                  </button>
                                </div>
                                <div style="width: 30%; float: left;">
                                  <button mat-raised-button color="warn" type="button" (click)="clearFormulario()"
                                            style="color: #fff; width: 99%; font-size: 12px ">
                                    Cancelar
                                  </button>
                                </div>

                              </div>




                          </div>
                      </div>
                  </mat-card>

                </div>



              <!--DIV DIREITA-->
              <!--container ajustado dinamicamente-->
              <div id="formAndList" style="margin-left: 10px;">

                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                  <div style=" margin-left: 15px; font-size: 14px;">Lista de Operações (Empresas)</div>
                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                  <mat-card class="mat-elevation-z8" style="padding: 8px;">



                      <!--container ajustado dinamicamente-->
                      <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilter($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>


                            <table mat-table [dataSource]="dataSource" matSort #sortOperacao="matSort"
                                class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                <!-- Position Column -->
                                <ng-container matColumnDef="operNmOperacao">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:40%;"> Empresa </th>
                                  <td mat-cell *matCellDef="let element" (click)="setFormUsuario(element)" style="width:40%; cursor: pointer;"> {{element.operNmOperacao}} </td>
                                </ng-container>

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="operDsCentroCusto">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Centro de Custo </th>
                                  <td mat-cell *matCellDef="let element" (click)="setFormUsuario(element)" style="width:30%; cursor: pointer;"> {{element.operDsCentroCusto}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="operDhInativo">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Inativo </th>
                                  <td mat-cell *matCellDef="let element"  (click)="setFormUsuario(element)" style="width:30%; cursor: pointer;"> {{element.operDhInativo}} </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 15px;"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns; " class="aoPassarMouse" style="height: 10px; "></tr>
                              </table>

                          </div>
                      </div>
                  </mat-card>

                </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </form>
    </mat-tab>
    <mat-tab *ngFor="let number of [0];let i=index;" label="📝 Cadastro Destinatários" >

      <form [formGroup]="destinatario" novalidate (ngSubmit)="salvarDestinatario()">

        <div>

          <!--Definir o tamanho da tela-->
          <div style=" width: 100%; overflow:hidden; text-align: center; ">

            <div style="width: 100%; height: 60px; background-color: rgb(51, 68, 75); text-align: center;">


                  <table style="width: 98%; margin-left: 10px;   ">
                    <tr>
                      <td style="width: 100%;  ">

                        &nbsp;

                      </td>
                    </tr>

                  </table>

            </div>
            <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>

          </div>


          <div style="margin-top: 15px; ">
            <!--container ajustado dinamicamente-->
            <div id="divContainer">

              <div id="divAdjustAutoHeight">

                <div style="margin-left: 5px; margin-right: 5px;">

                <!--DIV ESQUERDA-->
                <div id="formAndList">

                  <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                    <div style=" margin-left: 15px; font-size: 14px;">Novo / Editar cadastro </div>
                  </div>
                  <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                  <mat-card class="mat-elevation-z8" style="padding: 8px;">


                      <!--container ajustado dinamicamente-->
                      <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeight" style="overflow-y: auto;">
                            <mat-form-field  appearance="outline">

                              <mat-label style="text-align: left;">
                                <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                <b> Operação</b>
                                <i> (Empresa)</i>
                              </mat-label>

                              <mat-select formControlName="operIdCdOperacao"  (selectionChange)="onChangeOperacao($event)">
                                <mat-option *ngFor="let colunas of lstCmbOperacao"
                                            [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                              <mat-form-field appearance="outline" >
                                <mat-label>
                                  <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                  <b> E-mail destinatário</b>
                                  <i> (Obrigatório)</i>
                                </mat-label>
                                <input type="email" matInput formControlName="deopDsDestinatario" maxlength="200" onchange="this.value = this.value.toUpperCase()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <mat-label style="text-align: left;">
                                  <b> Tipo Destinatário</b>
                                  <i>(obrigatório)</i>
                                </mat-label>
                                <mat-select formControlName="idTideCdTipoDestinatario" style="font-size: 12px; font-weight: 500;">
                                  <mat-option *ngFor="let item of lstDestType; let i = index" [value]="item.idTideCdTipoDestinatario">{{item.tideDsTipoDestinatario}}</mat-option>
                                </mat-select>
                              </mat-form-field>

                              <div style="width:100%;  text-align: left; margin-top: 18px;">
                                <mat-slide-toggle style="font-size: 12px; " formControlName="deopDhInativo">Cadastro inativo?</mat-slide-toggle>
                              </div>

                              <div style="width: 100%; margin-top: 25px;">

                                <div style="width: 70%; float: left;">
                                  <button mat-raised-button  type="submit"
                                    style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                    Salvar
                                  </button>
                                </div>
                                <div style="width: 30%; float: left;">
                                  <button mat-raised-button color="warn" type="button" (click)="clearDestinatario()"
                                            style="color: #fff; width: 99%; font-size: 12px ">
                                    Cancelar
                                  </button>
                                </div>

                              </div>




                          </div>
                      </div>
                  </mat-card>

                </div>



              <!--DIV DIREITA-->
              <!--container ajustado dinamicamente-->
              <div id="formAndList" style="margin-left: 10px;">

                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                  <div style=" margin-left: 15px; font-size: 14px;">Lista de Destinatários (NCG)</div>
                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                  <mat-card class="mat-elevation-z8" style="padding: 8px;">



                      <!--container ajustado dinamicamente-->
                      <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilterDest($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>


                            <table mat-table [dataSource]="dataSourceDest" matSort #sortDest="matSort"
                                class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="deopDsDestinatario">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Destinatários </th>
                                  <td mat-cell *matCellDef="let element" (click)="setFormDestinatario(element)" style="width:30%; cursor: pointer;"> {{element.deopDsDestinatario}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="deopDhInativo">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Inativo </th>
                                  <td mat-cell *matCellDef="let element"  (click)="setFormDestinatario(element)" style="width:30%; cursor: pointer;"> {{element.deopDhInativo == null? 'Não' : 'Sim'}} </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDest; sticky: true" style="height: 15px;"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDest; " class="aoPassarMouse" style="height: 10px; "></tr>
                              </table>

                          </div>
                      </div>
                  </mat-card>

              </div>
              <!--container ajustado dinamicamente-->
              <div id="formAndList" style="margin-left: 10px; margin-top: 15px;">

                <div style="background-color: rgb(51, 68, 75); height: 30px; width: 100%; color: white; text-align: center; border-radius: 30px 30px 0px 0px;">
                  <div style=" margin-left: 15px; font-size: 14px;">Lista de Destinatários (CONTESTAÇÃO)</div>
                </div>
                <div style="margin-top: 0px; height: 5px; width: 100%; background-color: rgb(180, 180, 180)">&nbsp;</div>


                  <mat-card class="mat-elevation-z8" style="padding: 8px;">



                      <!--container ajustado dinamicamente-->
                      <div id="subDivContainer" style="width: 100%; ">
                          <div id="subDivAdjustAutoHeight" style="overflow-y: auto; font-size: 12px;">

                            <div style="width: 98%; margin-top: 5px; margin-left: 5px;" >
                              <mat-form-field class="example-full-width">
                                <mat-label>Buscar na lista </mat-label>
                                <input matInput (keyup)="applyFilterDest($event)" placeholder="Digite a busca de qualquer item na lista abaixo..." #input>
                              </mat-form-field>
                            </div>


                            <table mat-table [dataSource]="dataSourceDestCont" matSort #sortDestCont="matSort"
                                class="mat-elevation-z8" style="width: 98%;  margin-left: 7px; margin-bottom: 3px;  ">

                                <!-- Symbol Column -->
                                <ng-container matColumnDef="deopDsDestinatario">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Destinatários </th>
                                  <td mat-cell *matCellDef="let element" (click)="setFormDestinatario(element)" style="width:30%; cursor: pointer;"> {{element.deopDsDestinatario}} </td>
                                </ng-container>

                                <!-- Name Column -->
                                <ng-container matColumnDef="deopDhInativo">
                                  <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:30%;"> Inativo </th>
                                  <td mat-cell *matCellDef="let element"  (click)="setFormDestinatario(element)" style="width:30%; cursor: pointer;"> {{element.deopDhInativo == null? 'Não' : 'Sim'}} </td>
                                </ng-container>


                                <tr mat-header-row *matHeaderRowDef="displayedColumnsDest; sticky: true" style="height: 15px;"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsDest; " class="aoPassarMouse" style="height: 10px; "></tr>
                              </table>

                          </div>
                      </div>
                  </mat-card>

              </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </form>
    </mat-tab>
    <mat-tab *ngFor="let number of [0];let i=index;" label="📝 Fichas de monitoria" >
      <div>
        <!--Definir o tamanho da tela-->
        <div style=" width: 100%; overflow:hidden; text-align: center; ">
          teste
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

  </div>
